// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"469":"f0394f1a","663":"ef03f89a","744":"ef03f89a"}[chunkId] + ".chunk.css";
};